import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import DropIcon from '@material-ui/icons/ExpandMore';
// import { Link } from 'gatsby' USE WITH V2
import Link from 'gatsby-link'
import { withPrefix } from 'gatsby-link'

import withRoot from '../withRoot'
import css from './link.module.css'

class SimpleMenu extends React.Component {
  state = {
    anchorEl: null,
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;

    return (
      <div>
        <Button
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
        //   onMouseOver={this.handleClick}
        >
          Plant Lists<DropIcon />
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem onClick={this.handleClose} component={Link} to="/perennials/"><div>Perennials</div></MenuItem>
          <MenuItem onClick={this.handleClose} component={Link} to="/trees/"><div>Trees &amp; Shrubs</div></MenuItem>
          <MenuItem onClick={this.handleClose} component={Link} to="/wetland/"><div>Wetland</div></MenuItem>
          <MenuItem onClick={this.handleClose} component={Link} to="/ferns/"><div>Ferns</div></MenuItem>
          <MenuItem onClick={this.handleClose} className={css.other_link}><div><a href={withPrefix("../files/Trillium_Catalog.pdf")} download="Trillium_Catalog.pdf">Download Catalog</a></div></MenuItem>
        </Menu>
      </div>
    );
  }
}

export default withRoot(SimpleMenu)



// WEBPACK FOOTER //
// ./src/components/menu.js